export default `
mutation resumo($idProposta: String, $captchaResponse: String) {
    resumoFCG(payload: { id: $idProposta, captchaResponse: $captchaResponse }) {
      dados {
        id
        situacaoProposta
      }
      validatorResponse {
        errors {
          message
          category
        }
      }
    }
  }
`;
